<script>
import BreadcrumbsList from '@/components/breadcrumbsList';
import CategorySelector from "./categoriSelector";
import SearchBox from "./searchBox";
import Pagination from "./pagination";

export default {
  components: {
    BreadcrumbsList,
    CategorySelector,
    SearchBox,
    Pagination
  },
  data() {
    const { p, c, cn, s } = this.$route.query;

    return {
      current: p ? p - 1 : 0,
      selectedCategories: c ? typeof c === 'string' ? [c] : [...c] : [],
      search: s ? s : '',
      currentCutegory: cn ? cn : 0
    }
  },
  methods: {
    getQuery() {
      return 'query';
    }
  },
  computed: {
    params() {
      const { categoryName, selectedCategories, search } = this;
      const params = [];

      selectedCategories.forEach(category => {
        params.push([`${categoryName}.id`, category]);
      });
      if(search) params.push([ '_q', search ]);
      
      return params;
    },
    displayedArticle() {
      return this.articles;
    },
    categoryName() {
      const { categoryNames, currentCutegory } = this;
      return categoryNames[currentCutegory];
    }
  },
  async beforeMount() {
    if (this.params.length) {
      const articles = await this.$strapi.find(this.articlesName, this.params)
      this.articles = articles.data;
    }
  },
  watch: {
    async params(v, ov) {
      const { $strapi, perPage } = this;
      if(JSON.stringify(v) !== JSON.stringify(ov)) {
        const params = [...v];
        params.push( ['_limit', perPage] );
        const articles = await $strapi.find(this.articlesName, params)
        this.articles = articles.data;
        this.count = articles.count;
      }
    },
    async current(v) {
      const { perPage, $strapi } = this;
      const params = [...this.params];
      params.push([ '_start', v * perPage ], ['_limit', perPage]);
      const articles = await $strapi.find(this.articlesName, params)
      this.articles = articles.data;

      const query = { ...this.$route.query };
      if(v) {
        query.p = v + 1;
      } else {
        delete query.p;
      }
      this.$router.push({ query });
    },
    '$route.query.p': function(p) { this.current = p ? p - 1 : 0 },
    async categoryName(v) {
      this.categories = await this.$strapi.find(v);
    },
    async currentCutegory(v) {
      const query = { ...this.$route.query };
      if(v) {
        query.cn = v;
      } else {
        delete query.cn;
      }
      this.$router.push({ query });
    },
    '$route.query.cn': function(cn) { this.currentCutegory = cn ? cn : 0 },
    selectedCategories(v) {
      const query = { ...this.$route.query };
      if(v) {
        query.c = v;
      } else {
        delete query.c;
      }
      this.$router.push({ query });
    },
    '$route.query.c': function(c) { this.selectedCategories = c ? typeof c === 'string' ? [c] : [...c] : [] },
    search(v) {
      const query = { ...this.$route.query };
      if(v) {
        query.s = v;
      } else {
        delete query.s;
      }
      this.$router.push({ query });
    },
    '$route.query.s': function(s) { this.search = s ? s : '' }
  }
};
</script>
